
// stores 
import * as ProtocolsStore from '../../../../redux/middleware/MedicalProtocolMiddleware';
import * as PractitionerConsumptionStore from '../../../../redux/middleware/PractitionerConsumptionMiddleware';
import * as PractitionersStore from "../../../../redux/middleware/PractitionerMiddleware";

// state
import { AppState } from '../../../../redux/reducers';

// models
import { Practitioner } from "../../../../models/Entities/Practitioners/Practitioner";
import { PractitionerConsumption } from '../../../../models/Entities/Practitioners/PractitionerConsumption';
import { Protocol } from '../../../../models/Entities/Protocols/Protocol';

//#region Props

interface IProps {
    PractitionerId: string;
}

interface ConnectedProps {
    isLoading: boolean;
    successLoading: boolean;
    error: string | null;
    HaveConsumptionsToSettle: boolean;
    Consumptions: PractitionerConsumption[];
    Practitioner: Practitioner;
    GetPersonByIdentifier: (identifier: string) => Practitioner | undefined;
    GetProtocolById: (protocolId: number) => Protocol | null;
}

interface MedicalServicesDispatchProps {
    GetMedicalProtocolById: typeof ProtocolsStore.actionCreators.GetMedicalProtocolById;
    GetAllMedicalProtocols: typeof ProtocolsStore.actionCreators.GetAllMedicalProtocols;
    GetAllProtocolContractAssociations: typeof ProtocolsStore.actionCreators.GetAllProtocolContractAssociations;
    GetAllPractitioners: typeof PractitionersStore.actionCreators.GetAllPractitioners;
    // consumptions
    GetAllPractitionerConsumptionsByPractitioner: typeof PractitionerConsumptionStore.ActionCreators.GetAllPractitionerConsumptionsByPractitioner;
    GetPractitionerConsumptionsToSettle: typeof PractitionerConsumptionStore.ActionCreators.GetPractitionerConsumptionsToSettle;
    ChangeStatus: typeof PractitionerConsumptionStore.ActionCreators.ChangeStatus;
    DeletePractitionerConsumption: typeof PractitionerConsumptionStore.ActionCreators.DeletePractitionerConsumption;
    CreatePractitionerConsumption: typeof PractitionerConsumptionStore.ActionCreators.CreatePractitionerConsumption;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const practitioners = state.Practitioners?.list || [];
    
    const CurrentPractitioner = state.Practitioners?.list.find((practitioner: Practitioner) => practitioner.userId === ownProps.PractitionerId);

    return {
        isLoading: CurrentPractitioner?.isLoadingConsumptions || false,
        successLoading: false,
        error: undefined,
        HaveConsumptionsToSettle: false,
        Consumptions: CurrentPractitioner?.consumptions || [],
        Practitioner: CurrentPractitioner,
        GetPersonByIdentifier: (identifier: string) => GetPersonByIdentifier(practitioners, identifier),
        GetProtocolById: (protocolId: number) => state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === protocolId) || null
    }
};

export const mapDispatchToProps = {
    ...ProtocolsStore.actionCreators,
    ...PractitionerConsumptionStore.ActionCreators,
    ...PractitionersStore.actionCreators,
};


export const GetStatusDescription = (status: number): {description: string, class: string} => {

    /*
        NotSettled = 0,
        Pending = 1,
        Payee = 2,
        Settled = 3,
        Rejected = 4,
        Ignored = 5,
        ToSettle = 6

     */

    switch (status) {
        case 0:
            return {description: 'Pendiente de liquidación', class: 'status-not-settled'};
        case 1:
            return {description: 'Con saldo pendiente', class: 'status-pending'};
        case 2:
            return {description: 'Pagado', class: 'status-payee'};
        case 3:
            return {description: 'Liquidado', class: 'status-settled'};
        case 4:
            return {description: 'Rechazado', class: 'status-rejected'};
        case 5:
            return {description: 'Ignorado', class: 'status-ignored'};
        case 6:
            return {description: 'Por liquidar', class: 'status-to-settle'};
        default:
            return {description: 'Unknown', class: 'status-unknown'};
    }
}

 // get person by identifier
export const GetPersonByIdentifier = (persons: Practitioner[], identifier: string): Practitioner | undefined => {
  return persons.find((person: Practitioner) => person.userId === identifier);
}

export const GetRowClassByStatus = (status: number): string => {
    switch (status) {
        case 0:
            return ''; // 'status-not-settled-row';
        case 1:
            return ''; // 'status-pending-row';
        case 2:
            return 'status-payee-row';
        case 3:
            return 'status-settled-row';
        case 4:
            return ''; // 'status-rejected-row';
        case 5:
            return 'status-ignored-row';
        case 6:
            return 'status-to-settle-row';
        default:
            return ''; // 'status-unknown-row';
    }
}

export const GetTypeOfServiceDescription = (typeOfService: number): string | undefined => {
    switch (typeOfService) {
        case 1:
            return undefined;
        case 2:
            return 'Adicional';
        case 3:
            return 'Consulta a Domicilio';
        case 4:
            return 'No Esperado';
        default:
            return 'No Realizado';
    }
}